import React from "react";
import { Button, Tabs } from "devextreme-react";

class CardTabs extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: props.userData[0].Tabs[0],
      tabPosition: 0,

    };
  }

  componentDidUpdate = (prevprops) => {
    if (this.props.userData[0].Tabs[this.state.tabPosition] !== prevprops.userData[0].Tabs[this.state.tabPosition]) {
      this.setState({ data: this.props.userData[0].Tabs[this.state.tabPosition] });
    }
  }

  list = (tab) => {
    let info = [];
    if (tab.hasSeccion === false) {
      let pivot = [];
      pivot = tab.data.map((e, index) => (
        <div key={`${index}${new Date().getTime()}-${e.value}`} className="column row zero">
          <span className="text">  {e.label}: </span>
          {e.type === 'LINK' ? (
            <a href={e.url} target="_blank">
              <span className="value" title={e.tooltip}> {e.value || "S/D"} </span>
            </a>
          ) : (
            <span className="value" title={e.value}> {e.value || "S/D"} </span>
          )}
        </div>
      ));
      info.push(<div key={Math.random()} className="data-container"> {pivot} </div>);
    } else {
      const contador = tab.data.length;
      info = tab.data.map((item, index) => (
        <React.Fragment key={`secciones${index}${new Date().getTime() + (index * 0.2)}`}>
          {
            item.seccion.map((e, idx) => (
              <div key={`${idx}${index}${new Date().getTime()}-${e.value}`} className="column row zero">
                {
                  e.action === null && (
                    <React.Fragment>
                      <span className="text">  {e.label}: </span>
                      {e.type === 'LINK' ? (
                        <a href={e.url} target="_blank">
                          <span className="value" title={e.value}> {e.value}</span>
                        </a>
                      ) : (
                        <span className="value" title={e.value}> {e.value}</span>
                      )}
                    </React.Fragment>
                  )
                }
                {
                  (e.action === "edit" && e.showSucursal) && (
                    <React.Fragment>
                      <span className="text">  {e.label}: </span>
                      <span className="value" > {e.value}
                        <Button
                          key={e.Btn.id + index + e.value}
                          className="material-icons"
                          type="success"
                          style={{ backgroundColor: "Transparent" }}
                          onClick={() => e.Btn.onClickMethod(e)}
                        >
                          <i className="achs-icon" style={{ fontSize: 34, color: "#00B2A9", marginTop: "-13px" }} > T </i>
                        </Button>
                      </span>
                    </React.Fragment>
                  )
                }
                {
                  (e.action === "add" && e.showSucursal) && (
                    <React.Fragment>
                      <Button
                        key={e.Btn.id + index}
                        className={e.Btn.className}
                        type={e.Btn.type}
                        text={e.Btn.text}
                        onClick={() => e.Btn.onClickMethod(e)}
                        width={130}
                      >
                      </Button>
                    </React.Fragment>
                  )
                }

              </div>
            ))

          }
          {
            contador > index + 1 && (
              <div></div>)
          }
        </React.Fragment >
      ));
    }

    return (
      tab.hasSeccion && !tab.noShowSucursal ?
        <div className="data-container">
          {info}
        </div> :
        !tab.hasSeccion && !tab.noShowSucursal ?
          <div>{info}</div> :
          <div className="data-container-no-sucursal" >
            {info}
          </div >
    );
  }


  checkItem = (tab) => {
    this.setState({ data: tab.itemData, tabPosition: tab.itemIndex });
  }

  renderBox(Data, index, seccion) {
    const key = `${seccion}${new Date().getTime()}`;
    return (
      <div
        className="col-12"
        key={key}
      >
        <div className="row card-tabs" style={Data.noTopSpace ? { marginTop: 0, backgroundColor: Data.backgroudColor || "inherit" } : { backgroundColor: Data.backgroudColor || "inherit" }}>
          <div className="stick-content">
            <div className="content-circle">
              {Data.LettersCircle !== null && (
                <div className="col-12 circle" style={Data.background ? { background: Data.background } : { background: "inherit" }}>
                  <div className="text-circle">
                    {Data.LettersCircle}
                  </div>
                </div>
              )}
              {Data.Title !== null && (
                <div className="tab-title">
                  {Data.Title}
                </div>
              )}
              {Data.subTitle !== null && (
                <div className="tab-subtitle">
                  {Data.subTitle}
                </div>
              )}

            </div>
          </div>
          <div className="col-12 data-Info">
            {

              <div className="border-bottom-tabs">
                <Tabs
                  dataSource={Data.Tabs}
                  selectionMode="single"
                  onItemClick={this.checkItem}
                  className="header-tabs"
                  selectedIndex={this.state.tabPosition}
                  scrollByContent
                  noDataText="Sin acceso"
                  showNavButtons
                />
                {this.props.goBackCallback &&
                  <div
                    className="sucursal-back"
                    onClickCapture={this.props.goBackCallback}
                    style={{ backgroundColor: Data.backgroudColor || "inherit" }}
                  >
                    <i className="achs-icon icon">j</i>
                  </div>}
              </div>
            }

            {this.state.data !== null && (

              this.list(this.state.data)


            )}
          </div>

        </div>
      </div>
    );
  }

  render() {
    const {
      userData,
    } = this.props;

    return (
      <div>
        {userData.sort((a, b) => a.Header - b.Header).map((item, index) => this.renderBox(item, index, "usuario"))}
      </div>
    );
  }
}

export default CardTabs;
